export const all_routes = {
  // dashboard routes
  adminDashboard: "/index",
  centerDashboard: "/index",
  parentDashboard: "/parent-dashboard",
  studentDashboard: "/student-dashboard",
  teacherDashboard: "/teacher-dashboard",

  blankPage: "/blank-page",
  calendar: "/calendar",
  dataTables: "/data-tables",
  tablesBasic: "/tables-basic",
  notes: "/notes",
  comingSoon: "/coming-soon",

  // Configuration routes
  sessionList: "/session/session-list",
  sessionDetails: "/session/session-details",
  addSession: "/session/add-session",
  editSession: "/session/edit-session/:id",

  courseList: "/course/course-list",
  courseDetails: "/course/course-details",
  addCourse: "/course/add-course",
  editCourse: "/course/edit-course/:id",

  stageList: "/stage/stage-list",
  stageDetails: "/stage/stage-details",
  addStage: "/stage/add-stage",
  editStage: "/stage/edit-stage/:id",

  batchTimingList: "/batch-timing/batch-timing-list",
  addBatchTiming: "/batch-timing/add-batch-timing",
  editBatchTiming: "/batch-timing/edit-batch-timing/:id",

  // settings routes
  settingList: "/setting/setting-list",
  settingDetails: "/setting/setting-details",
  addSetting: "/setting/add-setting",
  editSetting: "/setting/edit-setting/:id",

  // Assessment routes
  assignMarks: "/assessment/assign-marks",

  // auth routes routes
  login: "/login",
  completeRegistration: "/complete-registration/:id",
  register: "/register",
  forgotPassword: "/forgot-password",
  twoStepVerification: "/two-step-verification",
  success: "/success",
  emailVerification: "/email-verification",
  lockScreen: "/lock-screen",
  resetPassword: "/reset-password",
  resetPasswordSuccess: "/reset-password-success",

  //ui routes
  alert: "/ui-alert",
  accordion: "/ui-accordion",
  avatar: "/ui-avatar",
  badges: "/ui-badges",
  border: "/ui-border",
  breadcrums: "/ui-breadcrums",
  button: "/ui-buttons",
  buttonGroup: "/ui-button-group",
  cards: "/ui-cards",
  carousel: "/ui-carousel",
  colors: "/ui-colors",
  dropdowns: "/ui-dropdowns",
  grid: "/ui-grid",
  images: "/ui-images",
  lightbox: "/ui-lightbox",
  media: "/ui-media",
  modals: "/ui-modals",
  navTabs: "/ui-navtabs",
  offcanvas: "/ui-offcanvas",
  pagination: "/ui-pagination",
  placeholder: "/ui-placeholder",
  popover: "/ui-popover",
  progress: "/ui-progress",
  rangeSlider: "/ui-rangeslider",
  spinner: "/ui-spinner",
  sweetalert: "/sweetalert",
  toasts: "/ui-toasts",
  tooltip: "/ui-tooltip",
  typography: "/ui-typography",
  video: "/ui-video",
  clipboard: "/ui-clipboard",
  counter: "/ui-counter",
  dragandDrop: "/ui-drag-drop",
  rating: "/ui-rating",
  ribbon: "/ui-ribbon",
  stickyNotes: "/ui-sticky-notes",
  textEditor: "/ui-text-editor",
  timeLine: "/ui-timeline",
  scrollBar: "/ui-scrollbar",
  apexChat: "/ui-apexchat",
  chart: "/ui-chartjs",
  featherIcons: "/ui-feather-icon",
  falgIcons: "/ui-flag-icon",
  fantawesome: "/ui-fantawesome",
  materialIcon: "/ui-material-icon",
  pe7icon: "/ui-icon-pe7",
  simpleLineIcon: "/ui-simpleline",
  themifyIcon: "/ui-themify",
  typicon: "/ui-typicon",
  weatherIcon: "/ui-weather-icon",
  basicInput: "/forms-basic-input",
  checkboxandRadion: "/form-checkbox-radios",
  inputGroup: "/form-input-groups",
  gridandGutters: "/form-grid-gutters",
  formSelect: "/form-select",
  formMask: "/form-mask",
  fileUpload: "/form-fileupload",
  horizontalForm: "/form-horizontal",
  verticalForm: "/form-vertical",
  floatingLable: "/form-floating-labels",
  formValidation: "/form-validation",
  reactSelect: "/select",
  formWizard: "/form-wizard",
  dataTable: "/tables-basic",
  tableBasic: "/data-tables",
  iconicIcon: "/icon-ionic",

  //base-ui
  uiAlerts: "/ui-alerts",
  uiAccordion: "/ui-accordion",
  uiAvatar: "/ui-avatar",
  uiBadges: "/ui-badges",
  uiBorders: "/ui-borders",
  uiButtons: "/ui-buttons",
  uiButtonsGroup: "/ui-buttons-group",
  uiBreadcrumb: "/ui-breadcrumb",
  uiCards: "/ui-cards",
  uiCarousel: "/ui-carousel",
  uiColor: "/ui-color",
  uiDropdowns: "ui-dropdowns",

  // pages routes
  error401: "/error-401",
  error404: "/error-404",
  error500: "/error-500",
  underMaintenance: "/under-maintenance",

  // settings routes
  emailSettings: "/settings/email-settings",

  customFields: "/app-settings/custom-fields",
  invoiceSettings: "/app-settings/invoice-settings",

  bankAccount: "/financial-settings/bank-ccount",
  paymentGateways: "/financial-settings/payment-gateways",
  taxRates: "/financial-settings/tax-rates",

  schoolSettings: "/academic-settings/school-settings",
  religion: "/academic-settings/religion",

  connectedApps: "/general-settings/connected-apps",
  notificationssettings: "/general-settings/notifications-settings",
  profilesettings: "/general-settings/profile-settings",
  securitysettings: "/general-settings/security-settings",

  banIpAddress: "/other-settings/ban-ip-address",
  storage: "/other-settings/storage",

  // emailSettings: "/system-settings/email-settings",
  emailTemplates: "/system-settings/email-templates",
  gdprCookies: "/system-settings/gdpr-cookies",
  smsSettings: "/system-settings/sms-settings",
  optSettings: "/system-settings/otp-settings",

  socialAuthentication: "/website-settings/social-authentication",
  companySettings: "/website-settings/company-settings",
  language: "/website-settings/language",
  localization: "/website-settings/localization",
  preference: "/website-settings/preference",
  prefixes: "/website-settings/prefixes",

  // application routes
  todo: "/application/todo",
  email: "/application/email",
  videoCall: "/application/video-call",
  chat: "/application/chat",
  audioCall: "/application/audio-call",
  callHistory: "/application/call-history",
  fileManager: "/application/file-manager",

  //content routes
  pages: "/content/pages",
  cities: "/content/cities",
  states: "/content/states",
  testimonials: "/content/testimonials",
  countries: "/content/countries",
  faq: "/content/faq",
  // blog
  allBlogs: "/content/all-blogs",
  blogCategories: "/content/blog-categories",
  blogComments: "/content/blog-comments",
  blogTags: "/content/blog-tags",

  //userManagement routes
  deleteRequest: "/user-management/delete-request",
  rolesPermissions: "/user-management/roles-permissions",
  manageusers: "/user-management/manage-users",
  permissions: "/user-management/permissions",

  //support routes
  contactMessages: "/support/contact-messages",
  tickets: "/support/tickets",
  ticketGrid: "/support/ticket-grid",
  ticketDetails: "/support/ticket-details",

  // membership routes
  membershipplan: "/membership-plans",
  membershipAddon: "/membership-addons",
  membershipTransaction: "/membership-transactions",

  // Notification routes
  notificationList: "/notifications/notification-list",
  notificationDetail: "/notifications/notification-detail/:id",
  addNotification: "/notifications/add-notification",
  editNotification: "/notifications/add-notification/:id",
  addCenterAdminNotification: "/notifications/add-center-admin-notification",
  editCenterAdminNotification:
    "/notifications/add-center-admin-notification/:id",
  notificationView: "/notifications/notification-view/:id",
  notificationFeedback: "/notifications/notification-feedback/:id",

  // Peoples Module
  centerList: "/centers/center-list",
  centerGrid: "/centers/center-grid",
  centerDetails: "/centers/center-details",
  centerDetailsId: "/centers/center-details/:id",
  addCenter: "/centers/center-add",
  editCenter: "/centers/center-edit/:id",
  centerUsers: "/centers/center-users",
  centerUsersId: "/centers/center-users/:id",
  centerProfile: "/centers/profile",
  addUser: "/centers/:id/users/add",
  editUser: "/centers/:id/users/edit/:userId",
  centerAnalytics: "/centers/center-analytics/:id",
  centerFeeDetails: "/centers/center-fee-details/:id",

  configureRegFeeShare: "/centers/center-reg-fee-share/:id",
  configureCourseFeeShare: "/centers/center-course-fee-share/:id",

  studentGrid: "/student/student-grid",
  studentPromotion: "/promotion/student-promotion",
  studentDetail: "/student/student-details/:id",
  studentAttendanceDetail: "/student/student-attendance-detail/:id",
  studentFees: "/student/student-fees/:id",
  studentFeesDiscount: "/student/student-fees-discount/:id/:invoiceId",
  studentFeesInvoice: "/student/student-fees-invoice/:id/:invoiceId",
  studentResult: "/student/student-result/:id",
  studentList: "/student/student-list",
  studentTransfers: "/student/student-transfers",
  billingSection: "/student/student-billing/:id",
  studentDocuments: "/student/student-documents/:id",
  importStudents: "/student/import-students",
  addStudent: "/student/add-student",
  quickRegister: "/student/quick-register",
  editStudent: "/student/edit-student/:id",
  generateStudentID: "/student/generate-student-id/:id",
  teacherDetails: "/teacher/teacher-details",
  teacherGrid: "/teacher/teacher-grid",
  teacherList: "/teacher/teacher-list",
  addTeacher: "/teacher/add-teacher",
  editTeacher: "/teacher/edit-teacher",
  teacherLibrary: "/teacher/teacher-library",
  teacherSalary: "/teacher/teacher-salary",
  teacherLeaves: "/teacher/teacher-leaves",
  teachersRoutine: "/teacher/teacher-routine",
  parentGrid: "/parent/parent-grid",
  parentList: "/parent/parent-list",
  guardiansGrid: "/parent/guardians-grid",
  guardiansList: "/parent/guardians-list",

  // Management
  feesType: "/management/fees-type",
  feesMaster: "/management/fees-master",
  feesAssign: "/management/fees-assign",
  feeConfiguration: "/management/fee-configuration",
  // collectFees:"/management/collect-fees",
  libraryMembers: "/management/library-members",
  libraryIssueBook: "/management/library-issue-book",
  libraryBooks: "/management/library-books",
  libraryReturn: "/management/library-return",
  playerList: "/management/players",
  sportsList: "/management/sports",
  hostelList: "/management/hostel-list",
  hostelType: "/management/hostel-type",
  hostelRoom: "/management/hostel-rooms",
  transportAssignVehicle: "/management/transport-assign-vehicle",
  transportVehicle: "/management/transport-vehicle",
  transportVehicleDrivers: "/management/transport-vehicle-drivers",
  transportPickupPoints: "/management/transport-pickup-points",
  transportRoutes: "/management/transport-routes",

  // Course Fee
  collectFees: "/fees-collection/collect-fees",
  feesConfiguration: "/fees-collection/course-fees-configuration",
  addFeeConfiguration: "/fees-collection/add-course-fee-configuration",
  editFeeConfiguration: "/fees-collection/edit-course-fee-configuration/:id",
  addFeeType: "/fees-collection/add-fee-type",
  editFeeType: "/fees-collection/edit-fee-type/:id",
  feeTypes: "/fees-collection/fee-types",
  generateInvoices: "/fees-collection/generate-invoices",
  paymentFeeDetails: "/fees-collection/payment-details",
  studentOfflinePayments: "/fees-collection/offline-payments",

  // Registration Fee
  courseRegistrationFee: "/fees-collection/registeration-fees-configuration",
  addCourseRegistrationFee:
    "/fees-collection/add-registeration-fee-configuration",
  editCourseRegistrationFee:
    "/fees-collection/edit-registeration-fee-configuration/:id",

  //Hrm module
  studentAttendance: "/hrm/student-attendance",

  layoutDefault: "/layout-default",
  layoutMini: "/layout-mini",
  layoutRtl: "/layout-rtl",
  layoutBox: "/layout-box",
  layoutDark: "/layout-dark",

  //page module
  profile: "/pages/profile",
  activity: "/pages/activities",

  // Fee Share
  addCourseFeeShare: "/course-fee-share/add",
  editCourseFeeShare: "/course-fee-share/edit/:id",
  courseFeeShareList: "/course-fee-share",
  addRegistrationFeeShare: "/registration-fee-share/add",
  editRegistrationFeeShare: "/registration-fee-share/edit/:id",
  registrationFeeShareList: "/registration-fee-share",
  viewRegistrationFeeShare: "/registration-fee-share/view/:id",
  viewCourseFeeShare: "/course-fee-share/view/:id",

  // Claims
  payShareList: "/pay-share",
  viewPayShare: "/pay-share/view/:id",

  // Book Request Module
  bookRequestList: "/books/book-requests",
  addBookRequest: "/books/book-requests/create",
  viewBookRequest: "/books/book-requests/:id",
  bulkBookRequest: "/books/bulk-book-requests",

  // Starter Kit Module
  starterKitInventory: "/starter-kit/inventory",
  starterKitTransactions: "/starter-kit/transactions",
  starterKitRequests: "/starter-kit/requests",
};
